import * as PropTypes from 'prop-types';
export var initialState = {
  nextKey: 0,
  ripples: []
};
export var propTypes = {
  /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */
  center: PropTypes.bool.isRequired,
  children: PropTypes.node,
  duration: PropTypes.number.isRequired,
  color: PropTypes.string.isRequired
};